import React, { Fragment } from "react";
import { string, func, bool, any } from "prop-types";
import * as style from "./styles.module.scss";
import ReadingListDownload from "../ReadingListDownload";

const ReadingList = ({
  title = "Reading List",
  description = "You are required to read each of these documents before you start work. Please download each one and read it fully, ensuring you tick the box to confirm you have read and understood. If you have any queries about the policies, please speak to your line manager.",
  readingListWithStatus,
  currentlyReading,
  setCurrentlyReading,
  markDocumentRead,
  getCompletedDocument,
  downloadedPdfs,
  isLoading = false,
  isGB = false,
  isKingspan = false,
  isDnata = false,
  isPecan = false,
  readingListWrapperCSS = "", // custom tailwind style property
}) => {
  return (
    <div
      className={`${style.readingList__wrapper} ${style.readingList} ${
        (isGB || isKingspan || isDnata || isPecan) && "w-100"
      } ${readingListWrapperCSS}`}
    >
      <div
        className={`${style.readingList__wrapper} shadow-sm rounded w-100 bg-white`}
      >
        <div className="p-1">
          <h5>{!isGB && title}</h5>
          <p>{description}</p>
        </div>
        {readingListWithStatus && readingListWithStatus.length !== 0 ? (
          <Fragment>
            {readingListWithStatus.map((_download, i) => {
              if (_download.title === "Night Worker Assessment") {
                return <Fragment key={_download.title} />;
              }
              return (
                <ReadingListDownload
                  key={i}
                  title={_download.title}
                  description={_download.description}
                  link={_download.link}
                  status={_download.status}
                  currentlyReading={currentlyReading}
                  setCurrentlyReading={setCurrentlyReading}
                  markDocumentRead={markDocumentRead}
                  getCompletedDocument={getCompletedDocument}
                  downloadedPdfs={downloadedPdfs}
                  isCustom={true}
                  isLoading={isLoading}
                  customAgreements={_download && _download.customAgreements}
                  agreementText={_download && _download.agreementText}
                  isGB={isGB}
                  isKingspan={isKingspan}
                  isDnata={isDnata}
                  isPecan={isPecan}
                />
              );
            })}
          </Fragment>
        ) : (
          <article>
            <h4>No documents have been added</h4>
            <p>
              Please come back when documents have been added for you to read.
            </p>
          </article>
        )}
      </div>
    </div>
  );
};

ReadingList.propTypes = {
  title: string,
  description: string,
  readingListWithStatus: any,
  currentlyReading: string,
  setCurrentlyReading: func,
  markDocumentRead: func,
  getCompletedDocument: func,
  downloadedPdfs: any,
  isLoading: bool,
  isGB: bool,
  isSB: bool,
  isDnata: bool,
  isPecan: bool,
  isKingspan: bool,
  readingListWrapperCSS: string,
};

export default ReadingList;
